/**
 * Lightweight error reporter for component store issues.
 * Logs to console and dispatches a DOM event that the canvas snackbar can pick up.
 *
 * Usage:
 *   import { reportStoreError } from '../../utils/storeErrorReporter';
 *   reportStoreError('conditional_workflow', componentId, 'addCondition', error);
 */

export function reportStoreError(componentType, componentId, action, error) {
  const message = `[STORE ERROR] ${componentType}/${componentId} — ${action} failed: ${error?.message || error}`;
  console.error(message, error);

  // Dispatch a global event so the canvas can show a snackbar
  window.dispatchEvent(new CustomEvent('storeError', {
    detail: {
      componentType,
      componentId,
      action,
      message: `Error in ${componentType}: ${action} failed. Please refresh and try again. If the issue persists, contact support with this info: ${componentType}/${componentId}/${action}`,
      error: error?.message || String(error),
    },
  }));
}

/**
 * Wraps a store action call with error reporting.
 * Returns true if successful, false if failed.
 */
export function safeStoreAction(store, action, args, componentType, componentId) {
  try {
    const state = store.getState();
    if (typeof state[action] !== 'function') {
      reportStoreError(componentType, componentId, action, new Error(`Action "${action}" not found on store`));
      return false;
    }
    state[action](...args);
    return true;
  } catch (error) {
    reportStoreError(componentType, componentId, action, error);
    return false;
  }
}
